module.exports = __webpack_public_path__ + "img/specials-multislider-nissan.ce01d968.png";